import React from 'react';
import { Alert, Box, Stack, TextField } from '@mui/material';
import { MAX_SEARCH_JOBS } from '../../utils/optimizerSearchRanges';
import PortfolioDesignCompare from './PortfolioDesignCompare';

export function OptimizerSearchSettings({ search }) {
    return <Stack direction="row" alignItems="center" gap={1.5} flexWrap="wrap">
        {[
            ['trial_budget', 'Search runs', 1, MAX_SEARCH_JOBS],
            ['search_seconds', 'Total time limit (seconds)', 10, 3600],
            ['trial_seconds', 'Per-run limit (seconds)', 1, 60],
        ].map(([key, label, min, max]) => <TextField key={key} type="number" size="small" label={label}
            value={search.options[key]} disabled={search.busy} sx={{ width: 180 }} inputProps={{ min, max }}
            onChange={(e) => search.setOptions((previous) => ({ ...previous, [key]: e.target.value === '' ? '' : Number(e.target.value) }))} />)}
    </Stack>;
}

export default function OptimizerSearchPanel({ search }) {
    return <Box sx={{ minWidth: 0 }}>
        {search.model.study ? <PortfolioDesignCompare model={search.model} selection={search.selection} />
            : <Alert severity="info">Run a new job with at least one constraint set to Auto to see search results.</Alert>}
    </Box>;
}
